<template>
  <div>
    <rc-btn
      data-bs-target="#accessibilityInfos"
      aria-expanded="false"
      aria-controls="accessibilityInfos"
      data-bs-toggle="collapse"
      variant="primary"
      size="lg"
      class="rc-btn-toggle"
    >
      <span>{{ $t("a11y.button.info") }}</span>
      <RcIcon
        name="chevronUpBold"
        scale=".55"
      />
      <RcIcon
        name="chevronDownBold"
        scale=".55"
      />
    </rc-btn>

    <div
      id="accessibilityInfos"
      class="collapse mb-3"
    >
      <div class="card">
        <div class="card-body">
          <div v-html="$t('a11y.player.intro')" />
          <div class="table-responsive">
            <table
              role="table"
              class="table table-borderless"
            >
              <thead role="rowgroup">
                <tr role="row">
                  <th
                    role="columnheader"
                    scope="col"
                  >
                    Action
                  </th>
                  <th
                    role="columnheader"
                    scope="col"
                  >
                    {{ $t("a11y.key") }}
                  </th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <!-- non player specic -->
                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.play.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.play.key") }}
                  </td>
                </tr>
                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.full_screen.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.full_screen.key") }}
                  </td>
                </tr>
                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.full_screen_exit.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.full_screen_exit.key") }}
                  </td>
                </tr>
                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.mute.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.mute.key") }}
                  </td>
                </tr>

                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.volume.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.volume.key") }}
                  </td>
                </tr>
                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.backward_10sec.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.backward_10sec.key") }}
                  </td>
                </tr>
                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.forward_10sec.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.forward_10sec.key") }}
                  </td>
                </tr>

                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.cc.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.cc.key") }}
                  </td>
                </tr>

                <tr role="row">
                  <td role="cell">
                    {{ $t("a11y.player.dv.action") }}
                  </td>
                  <td role="cell">
                    {{ $t("a11y.player.dv.key") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RcIcon from '@/libvue/components/icons/Base.vue';
export default {
  name: 'RcA11yPlayer',
  components: {
    RcIcon
  }
};
</script>
<style lang="scss">
#accessibilityInfos .table-responsive {
  margin-bottom: 0;
  table {
    max-width: 40rem;

    th,
    td {
      padding: 0.5rem 0.5rem 0.5rem 0;
      border-bottom: 1px solid var(--bs-light);
    }
    tr:last-child {
      td {
        border-bottom: 0;
      }
    }
  }
}
</style>
